import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100% - 53.3px);
    width: 100vw;
}
`;
